export default __webpack_public_path__ + "static/1-a0975c2109340134041eda94e31836a0.jpg";